import { addToast } from "@caprikorn/dynamo-ui";
import { downloadData } from "@caprikorn/dynamo-utils";
import { useMutation } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import type { UseGetPerimeterExportDownloadParams } from "./apiEcms.types";

const getPerimeterExportDownload = () =>
  apiEcmsHttp.get<Blob>("/perimeter-export/download", {
    responseType: "blob",
  });

export const useGetPerimeterExportDownload = ({
  groupName,
  supportEmail,
}: UseGetPerimeterExportDownloadParams) => {
  const { currentGroup } = useGroupReferences();
  const { t } = useCustomTranslation("main");

  return useMutation({
    mutationKey: [
      QUERY_KEYS.PERIMETER_EXPORT_DOWNLOAD,
      groupName,
      currentGroup,
    ],
    mutationFn: getPerimeterExportDownload,
    onSuccess: (response) => {
      downloadData(`${groupName}_perimeter_extract.csv`, response.data);
    },
    onError: () => {
      addToast({
        variant: "error",
        title: t("documents.toast.extractGenerationError.title"),
        description: t("documents.toast.extractGenerationError.description", {
          supportEmail,
        }),
      });
    },

    retry: false,
  });
};
